import { useMemo } from "react"
import { useSelector } from "react-redux"
import { LevelSettingType } from "@/api/FacilityLevelsService"
import { RootState } from "@/store"

export function useJmsEnabled(): boolean {
   const { facilityDetails } = useSelector(
      ({ facilitiesReducer }: RootState) => facilitiesReducer
   )

   return useMemo(() => {
      const settings = facilityDetails.settings
      if (!settings || settings.length === 0) return false
      const setting = settings.find(
         (settingItem) => settingItem.key === LevelSettingType.JMS_DATA_PROVIDER
      )
      return setting !== undefined && setting.value !== null
   }, [facilityDetails.settings])
}
